import { api } from "..";

export function createContactRequest(data) {
  return api.post("/v1/contact/create", data);
}

export function updateContactRequest({ id, data }) {
  return api.put(`/v1/contact/${id}`, data);
}

export function getContactRequest({ params }) {
  return api.get(`/v1/contact`, {
    params,
  });
}

export function getContactByIdRequest({ id, params }) {
  return api.get(`/v1/contact/${id}`, { params });
}

export function createSystemUserRequest({ contactId, data }) {
  return api.post(`/v1/user/create-system-user/${contactId}`, data);
}

export function updateSystemUserRequest({ contactId, data }) {
  return api.put(`/v1/user/update-system-user/${contactId}`, data);
}
